import { render } from "./header.vue?vue&type=template&id=c6c54ec8"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=c6c54ec8&lang=css"
script.render = render

export default script